import { render, staticRenderFns } from "./NewBaseTemplate.vue?vue&type=template&id=27b3526b&scoped=true&"
import script from "./NewBaseTemplate.vue?vue&type=script&lang=js&"
export * from "./NewBaseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./NewBaseTemplate.vue?vue&type=style&index=0&id=27b3526b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b3526b",
  null
  
)

export default component.exports